package floris.graphics.models.dto.requests.category

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InsertCategory(
    val name: String = "",
    @SerialName("parent_category_id")
    val parentCategoryId: String? = null
) {
    // With the insert, the parentCategoryId is not mandatory, so should not be checked
    val isValid get() = name.isNotBlank()
}